<template>
  <div class="content">
    <div class="pro-mobile">
      <menu-mobile />
    </div>
    <div class="redeem-frame">
      <form class="review-redeem-frame" @submit.prevent>
        <p class="text-content">
          {{ $t('Bao.coupon_notice') }}
        </p>
        <label for="exampleInputEmail1" class="form-label input-titel">{{ $t('Bao.coupon_code') }}</label>
        <input
          id="exampleInputEmail1"
          v-model="couponCode"
          type="email"
          class="form-control redeem-code"
          aria-describedby="emailHelp"
          :placeholder="$t('Bao.coupon_input')"
        >
        <button class="btn btn-primary button-style-w100 btn-redeem-code mx-auto" @click.prevent="redeemCoupon">
          {{ $t('Bao.redeem') }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { couponExchange } from '@/api/user'
import { showNotice } from '@/utils/tool'
import menuMobile from '@/components/shop/menuMobile'

export default {
  components: {
    menuMobile
  },
  data() {
    return {
      couponCode: '',
      responseMsg: '',
      responseCode: null
    }
  },
  computed: {
    redeemMsg() {
      if (this.responseMsg && this.$store.state.user.memberInfo.member_type === 1 || this.$store.state.user.memberInfo.member_type === 2 && this.$store.getters.language) {
        return this.$t('Bao.coupon_identity')
      } else {
        if (this.$store.getters.language) {
          const code = Math.abs(this.responseCode)
          return this.$t('Bao.coupon_exchange_error_' + code)
        }
      }
      return this.responseMsg
    }
  },
  methods: {
    redeemCoupon() {
      couponExchange({ coupon_code: this.couponCode }).then((response) => {
        this.responseMsg = response.data.data.exchange.message
        this.responseCode = response.data.data.exchange.code
        showNotice(this.redeemMsg)
      }).catch(() => {
        showNotice(this.$t('Bao.coupon_exchange_error'))
      })
    }
  }
}
</script>

<style scoped>

</style>
